import { render } from "./g-clean-layout.vue?vue&type=template&id=67dc0c1c&ts=true"
import script from "./g-clean-layout.vue?vue&type=script&lang=tsx"
export * from "./g-clean-layout.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__